export default __webpack_public_path__ + "static/media/App.f6ee784e.less";